import type { IAuthUser } from '@/shared/types/auth-user'

export function readStoredUser(): IAuthUser | null {
  const raw = localStorage.getItem('user')
  if (!raw) return null
  try {
    return JSON.parse(raw) as IAuthUser
  } catch {
    return null
  }
}
